import Vue from 'vue'
import App from './app'
import router from '@router'
import store from '@state/store'
import '@components/_globals'
import VueI18n from 'vue-i18n'
import BootstrapVue from 'bootstrap-vue'
import Vuelidate from 'vuelidate'
import Datetime from 'vue-datetime'
import 'vue-datetime/dist/vue-datetime.css'
import VueScrollTo from 'vue-scrollto'
import VueAnalytics from 'vue-analytics'
import VueGtm from 'vue-gtm'
import VueGtag from 'vue-gtag'
import { callToLoadAnalytics } from '@state/helpers'

// Don't warn about using the dev version of Vue in development.
Vue.config.productionTip = process.env.NODE_ENV === 'production'

// If running inside Cypress...
if (window.Cypress) {
  // Ensure tests fail when Vue emits an error.
  Vue.config.errorHandler = window.Cypress.cy.onUncaughtException
}

Vue.use(VueI18n)
Vue.use(BootstrapVue)
Vue.use(Vuelidate)
Vue.use(Datetime)
Vue.use(VueScrollTo)

callToLoadAnalytics()
  .then((response) => {
    // true means recaptchaV3 challenge was passed
    if (response === true) {
      loadAnalytics()
    }
  })
  .catch((error) => {
    // eslint-disable-next-line no-console
    console.log(error)
    loadAnalytics()
  })

export const messages = {
  en: {
    pages: {
      home: {
        contentSections: {
          hero: {
            content:
              '<h3>Why do used car <br> shoppers choose <br> AutoCheck?</h3>\n' +
              "              <h5>Here's what people are saying:</h5>\n" +
              '              <p>\n' +
              '                &nbsp;"AutoCheck was well worth every penny I paid - saved me lots of time  &amp; money\n' +
              '                (made dealing with auto dealers 100% easier). I would  certainly recommend AutoCheck to\n' +
              '                anyone in the market for a vehicle." -  Satisfied User\n' +
              '                <br> <br>\n' +
              '                "I owe my success in buying a used car to you guys. Your research and  data gathered is\n' +
              '                invaluable input to this important buying decision.  Thanks for being there." - Recent Purchaser\n' +
              '              </p>',
            description: 'Content section on home page hero banner',
          },
          getAnswers: {
            content:
              '<h2>Get The AutoCheck Report</h2>\n' +
              '            <h3 class="titleBlue">Step 1. Find Your Car</h3>\n' +
              '            <p>Search by vehicle identification number (VIN) or US license plate to find the car you want to research.</p>\n' +
              '            <h3 class="titleBlue">Step 2. Pick Your Plan</h3>\n' +
              "            <p>Multiple Reports if you're still shopping and considering many vehicles. A single report might be right for\n" +
              "              you if you've found your dream car and are ready to buy.</p>\n" +
              '            <h3 class="titleBlue">Step 3. Check Your Vehicle History</h3>\n' +
              '            <p>from your desktop. One time fee. No recurring charges</p>',
            textStrings: {},
            description:
              'Section below hero banner - Get Answers to questions about AutoCheck',
          },
          scanQuickly: {
            content:
              '<h2>Scan Quickly</h2>\n' +
              '                <h3 class="titleBlue">The AutoCheck Score</h3>\n' +
              '                <img src="/images/ScanQuickly238.png" alt="Scan Quickly"/>\n' +
              '                <p>Spot your perfect vehicle quickly with the patented AutoCheck Score and minimize the risk of buying a vehicle with unseen problems.</p>',
            description:
              'Content section column describing benefits of AutoCheck - Scan Quickly',
          },
          deepDive: {
            content:
              '<h2>Dive in Deep</h2>\n' +
              '                <h3 class="titleBlue">Full Vehicle Histories</h3>\n' +
              '                <img src="/images/DiveInDeepReports204.png" alt="Dive in Deeper"/>\n' +
              '                <p>Learn if a vehicle has been reported in an accident, branded a lemon, damaged in a flood, reported repossessed or stolen, and more.</p>',
            description:
              'Content section column describing benefits of AutoCheck - Dive in Deep',
          },
          restEasy: {
            content:
              ' <h2>Rest Easy</h2>\n' +
              '                <h3 class="titleBlue">Backed by Experian</h3>\n' +
              '                <img src="/images/RestEasy178.png" alt="Buyback Protection"/>\n' +
              '                <p>Be confident in your purchase and enjoy access to benefits such as free Buyback Protection for registered, qualified vehicles. </p>',
            description:
              'Content section column describing benefits of AutoCheck',
          },
        },
        metaData: {
          title: 'AutoCheck.com | Homepage',
          description:
            'Purchase an AutoCheck vehicle history report. Be informed while shopping for a used car by exploring our reports, resources and tips.',
        },
      },
      login: {
        h1: 'Sign In or Create a New Account',
      },
      contact: {
        h1: 'Contact Us',
      },
    },
    components: {
      vehicleSearch: {},
      login: {},
      registration: {},
    },
  },
}

// Create VueI18n instance with options
const i18n = new VueI18n({
  locale: 'en', // set locale
  messages, // set locale messages
})

const app = new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')

// If running inside Cypress...
if (window.Cypress) {
  // Attach the app to the window, which can be useful
  // for manually setting state in Cypress commands
  // such as `cy.logIn()`.
  window.__app__ = app
}

function loadAnalytics() {
  var gaAccount = process.env.VUE_APP_GA_ACCOUNT

  // TODO: remove legacy way of loading analytics once Analytics 360 is no more
  Vue.use(VueAnalytics, {
    id: gaAccount, // Your GA ID; the value can be found in the .env.* files located in the root directory
    router,
    // debug: {
    //   enabled: true
    // },
    ecommerce: {
      enabled: true,
    },
  })

  var gtmAccount = process.env.VUE_APP_GTM_ACCOUNT
  Vue.use(VueGtm, {
    id: gtmAccount, // Your GTM ID; the value can be found in the .env.* files located in the root directory
    enabled: true, // defaults to true. Plugin can be disabled by setting this to false for Ex: enabled: !!GDPR_Cookie (optional)
    debug: false, // Whether or not display console logs debugs (optional)
    vueRouter: router, // Pass the router instance to automatically sync with router (optional)
  })

  const ga4MeasurementId = process.env.VUE_APP_GA_MEASUREMENT_ID

  Vue.use(VueGtag, {
    config: {
      id: ga4MeasurementId,
    },
  })
  // get the latest siteID value when a user leaves the website.
  // this is to try and mock a session level scope of a custom dimension in GA4
  window.onbeforeunload = function() {
    if (window.gtag) {
      window.gtag('event', 'capture_site_id_on_page_unload', {
        siteID_once_per_session: document.getElementById('siteID').value,
      })
    }
  }
}
